/** @typedef {'gallery' | 'camera'} PhotoSourceChoice */

let pendingResolve = null;
/** @type {((open: boolean) => void) | null} */
let setOpenHandler = null;

/**
 * 사진 소스 선택 바텀시트를 연다.
 * @returns {Promise<PhotoSourceChoice | null>}
 */
export function openPhotoSourceSheet() {
  return new Promise((resolve) => {
    pendingResolve = resolve;
    setOpenHandler?.(true);
  });
}

/** @internal PhotoSourceBottomSheetHost 전용 */
export function registerPhotoSourceSheetHost(setOpen) {
  setOpenHandler = setOpen;
}

/** @internal */
export function resolvePhotoSourceSheet(choice) {
  pendingResolve?.(choice);
  pendingResolve = null;
  setOpenHandler?.(false);
}

/** @internal */
export function dismissPhotoSourceSheet() {
  resolvePhotoSourceSheet(null);
}
